module.exports = __webpack_public_path__ + "static/media/beliefs@3x.8851d002.png";